import { createAssetManagementClient } from '@/shared/api/client'
import { z } from 'zod'
import { updateInvoiceCategoriesSchema } from '@/features/invoices/schemas'
import { validateResponseIsOk } from '@/shared/api/validation'

const client = createAssetManagementClient()

export const updateInvoiceTemplateCategories = (assetCode: string, categories: z.infer<typeof updateInvoiceCategoriesSchema>) =>
  validateResponseIsOk(
    client.sendPatch(
      `assets/${assetCode}/invoices/categories`,
      { data: updateInvoiceCategoriesSchema.parse(categories) }
    )
  ).then(
    () => { }
  )
